<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">倉庫明細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="$router.go(-1)">戻る</v-btn>
      </v-card-actions>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex md3 sm6 xs12>
            <remote-autocomplete
              label="納入場所"
              url="warehouses/reservable-kv"
              v-model="query.warehouseId"
            ></remote-autocomplete>
          </v-flex>
          <v-flex md3 sm6 xs12>
            <remote-autocomplete
              label="所属事業本部"
              clearable
              v-model="query.buId"
              url="/divisions/kv?type=BU"
            />
          </v-flex>
          <v-flex md3 sm6 xs12>
            <remote-autocomplete
              label="所属BU"
              clearable
              v-model="query.businessUnitId"
              url="/divisions/kv?type=BUSINESS_UNIT"
            />
          </v-flex>
          <v-flex md3 sm6 xs12>
            <v-btn v-if="isMe" @click="editLogisticsSku()"
              >物流社内品番明細</v-btn
            >
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <v-card>
      <v-card-text>
        <div class="row-0">
          <div>
            <div style="padding: 15px 20px; display: flex">
              <div style="margin-right: 20px">
                <label style="font-weight: bold; display: inline-block"
                  >海外取引先:</label
                >
                {{ shipment.partnerName }}
              </div>
              <div style="margin-right: 20px">
                <label style="font-weight: bold; display: inline-block"
                  >積出港:</label
                >
                {{ shipment.loadingPortName }}
              </div>
              <div style="margin-right: 20px">
                <label style="font-weight: bold; display: inline-block"
                  >陸揚港:</label
                >
                {{ shipment.dischargePortName }}
              </div>
              <div style="margin-right: 20px">
                <label style="font-weight: bold; display: inline-block"
                  >B/L No:</label
                >
                {{ shipment.blNo }}
              </div>
              <div style="margin-right: 20px">
                <label style="font-weight: bold; display: inline-block"
                  >コンテナNo:</label
                >
                {{ shipment.containerNos }}
              </div>
              <div style="margin-right: 20px">
                <label style="font-weight: bold; display: inline-block"
                  >品種Group:</label
                >
                {{ shipment.primaryProductGroupName }}
              </div>
              <div style="margin-right: 20px">
                <label style="font-weight: bold; display: inline-block"
                  >品種名:</label
                >
                {{ shipment.primaryProductName }}
              </div>
              <div style="margin-right: 20px">
                <label style="font-weight: bold; display: inline-block"
                  >代表品番:</label
                >
                {{ shipment.primarySkuCode }}
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <v-card class="mt-2">
      <fixed-column-wrap :data="displayResults">
        <template slot-scope="{}">
          <v-data-table
            :headers="headers"
            :items="displayResults"
            :loading="loading"
            :rows-per-page-items="[-1]"
            item-key="[0].id"
            v-model="selected"
            select-all
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-if="false"
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>
                {{ getWarehouse(props.item[0]) }}
              </td>
              <td>
                {{ getBu(props.item[0]) }}
              </td>
              <td>
                {{ getBusinessUnit(props.item[0]) }}
              </td>
              <td>
                <div v-for="item in getProductGroup(props.item)" :key="item.id">
                  {{ item[0].productGroupName }}
                </div>
              </td>

              <td v-for="date in availableDays" :key="date">
                <div class="qtyLeft">
                  <div>
                    <div
                      class="qty"
                      v-for="item in getProductGroup(props.item)"
                      :key="item.id"
                    >
                      {{ getUpperLimit(date, item) }}
                    </div>
                  </div>
                  <v-btn
                    class="btn-search"
                    @click="reserve(props.item, date)"
                    v-if="
                      $route.query.type !== 'multiply' &&
                        canReserve(props.item, date)
                    "
                    >予約</v-btn
                  >
                </div>
              </td>
            </template>
          </v-data-table>
        </template>
      </fixed-column-wrap>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="virtualHeaders"
        :items="virtualDisplayResults"
        :loading="loading"
        :rows-per-page-items="[-1]"
        item-key="[0].id"
        v-model="selected"
        select-all
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-if="false"
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>
            {{ getWarehouse(props.item[0]) }}
          </td>
          <td>
            {{ getBu(props.item[0]) }}
          </td>
          <td>
            {{ getBusinessUnit(props.item[0]) }}
          </td>
          <td>
            <div v-for="item in getProductGroup(props.item)" :key="item.id">
              {{ item[0].productGroupName }}
            </div>
          </td>

          <td v-for="date in virtualAvailDays" :key="date">
            <div class="qtyLeft">
              <div>
                <div
                  class="qty"
                  v-for="item in getProductGroup(props.item)"
                  :key="item.id"
                >
                  {{ getUpperLimit(date, item) }}
                </div>
              </div>
              <v-btn
                class="btn-search"
                @click="reserve(props.item, date)"
                v-if="canVirtualReserve(props.item, date)"
                >予約</v-btn
              >
            </div>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <logistics-sku-detail ref="logistics"></logistics-sku-detail>
    <long-distance-dialog ref="longDistanceDialog"></long-distance-dialog>
  </v-container>
</template>

<script>
import LogisticsSkuDetail from '../B0600/LogisticsSkuDetail.vue'
import DateFormat from 'dateformat'
import LongDistanceDialog from './LongDistanceDialog'
export default {
  components: {
    LogisticsSkuDetail,
    LongDistanceDialog,
  },
  data() {
    return {
      query: {},
      remark: '',
      successShipments: [],
      failedShipments: [],
      selected: [],
      results: [],
      workingAvailableDays: [],
      basicAvailableDays: [],
      availableDays: [],
      virtualAvailDays: [],
      displayResults: [],
      virtualDisplayResults: [],
      loading: false,
      pagination: {
        page: 1,
      },
      query: {},
      headers: [
        {
          text: '納入場所',
          value: '',
          sortable: false,
          class: 'fixed',
        },
        {
          text: '事業本部',
          value: '',
          sortable: false,
          class: 'fixed',
        },
        {
          text: 'BU',
          value: '',
          sortable: false,
          class: 'fixed',
        },
        {
          text: '品種グループ',
          value: '',
          sortable: false,
          class: 'fixed',
        },
      ],
      virtualHeaders: [
        {
          text: '納入場所',
          value: '',
          sortable: false,
          class: 'fixed',
        },
        {
          text: '事業本部',
          value: '',
          sortable: false,
          class: 'fixed',
        },
        {
          text: 'BU',
          value: '',
          sortable: false,
          class: 'fixed',
        },
        {
          text: '品種グループ',
          value: '',
          sortable: false,
          class: 'fixed',
        },
      ],
      virtualWarehouses: [],
      date: new Date(),
      errors: {
        NO_PRODUCT_GROUP:
          '品種グループが登録されていないので、利用可能倉庫が見つかりません。',
        NO_LIMIT: '当該倉庫に品種グループが登録されていません。',
        QTY_OVER: '予約可能本件を超えました。',
        DIFFERENT_BUSINESS_UNIT: 'BUが一致しないので、予約できません。',
        EMPTY_FREE_DAYS:
          'FreeDaysが見つかりません。SJL担当者にご連絡お願いします。',
      },
      currentData: null,
      currentDate: null,
      shipment: {},
    }
  },

  methods: {
    editLogisticsSku() {
      this.$refs.logistics.popup(this.shipment.packages)
    },
    load() {
      var id = this.$route.query.id
      var query = {
        startDate: this.availableDays[0],
        endDate: this.availableDays[this.availableDays.length - 1],
      }
      this.$http
        .get(
          `/warehouse-container-settings/shipment/${id}/reserve-warehouses`,
          {
            params: {
              ...query,
            },
          }
        )
        .then((res) => {
          var tempData = res.data.filter((r) => !r.virtualWarehouse)
          tempData.forEach((td) => {
            if ('WORKING_CALENDAR' === td.calendarType) {
              td.availableDays = this.workingAvailableDays
            } else {
              td.availableDays = this.basicAvailableDays
            }
          })
          this.results = this.initData(tempData)
          console.log(this.results)
          this.results = this.results.sort((a, b) => {
            return this.$sortByProps(a[0], b[0], {
              warehouseCode: 'desc',
              buId: 'desc',
            })
          })
          this.results.forEach((r) => {
            r = r.sort((a, b) => {
              return this.$sortByProps(a, b, {
                productGroupName: 'desc',
              })
            })
          })
          this.results = this.results.sort((a, b) => {
            return this.$sortByProps(a[0], b[0], {
              seq: 'ascending',
            })
          })
          this.displayResults = this.results
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    initDate() {
      var id = this.$route.query.id
      this.$http
        .get(
          `/warehouse-container-settings/shipment/${id}/available-days?calendarType=WORKING_CALENDAR`
        )
        .then((res) => {
          this.workingAvailableDays = res.data
          this.$http
            .get(
              `/warehouse-container-settings/shipment/${id}/available-days?calendarType=BASIC_CALENDAR`
            )
            .then((bRes) => {
              this.basicAvailableDays = bRes.data
              this.initAvailDays()
            })
        })
        .catch((err) => {
          this.$showError(err)
        })
    },

    initAvailDays() {
      this.workingAvailableDays.forEach((w) => {
        if (this.availableDays.indexOf(w) === -1) {
          this.availableDays.push(w)
        }
      })
      this.basicAvailableDays.forEach((b) => {
        if (this.availableDays.indexOf(b) === -1) {
          this.availableDays.push(b)
        }
      })
      this.availableDays = this.availableDays.sort((a, b) => a.localeCompare(b))
      this.availableDays.forEach((day) => {
        this.headers.push({
          text: day,
          sortable: false,
        })
      })
      if (this.availableDays.length === 0) {
        this.$message(
          'ERROR',
          '正常納入指示期間にありませんので、予約ができません。'
        )
      } else {
        this.load()
      }
    },
    addDate(date, days) {
      var d = new Date(date)
      d.setDate(d.getDate() + days)
      var m = d.getMonth()
      return new Date(d.getFullYear(), m, d.getDate()).format('yyyy-MM-dd')
    },
    initData(data) {
      var a = this.groupBy(data, function(item) {
        return [item.warehouseId, item.buId, item.businessUnitId]
      })
      a = a.sort((x, y) => (x[0].seq || 9999) - (y[0].seq || 9999))
      return a
    },
    groupBy(array, f) {
      let groups = {}
      array.forEach(function(o) {
        let group = JSON.stringify(f(o))
        groups[group] = groups[group] || []
        groups[group].push(o)
      })
      return Object.keys(groups).map(function(group) {
        return groups[group]
      })
    },
    getWarehouse(item) {
      return item.warehouseCode + ':' + item.warehouseName
    },
    getBu(item) {
      if (item.companyName) {
        return item.companyName
      }
      return item.buCode + ':' + item.buName
    },
    getBusinessUnit(item) {
      return item.businessUnitName
    },
    getProductGroup(data) {
      var a = this.groupBy(data, function(item) {
        return [item.productGroupName]
      })
      return a
    },
    getUpperLimit(date, dataSource) {
      var setting = dataSource.find((d) => date === d.date)
      if (setting) {
        return setting.upperLimit - setting.used
      }
      return 0
    },
    canReserve(data, date) {
      return (
        data[0].availableDays.indexOf(date) !== -1 &&
        data
          .filter(
            (d) => !d.buCode || d.buCode === this.shipment.headquarterCode
          )
          .filter(
            (d) =>
              !d.businessUnitId ||
              d.businessUnitId === this.shipment.primaryBusinessUnitId
          )
          .filter((d) => d.date === date)
          .filter((d) => d.reservable && d.upperLimit - d.used > 0).length > 0
      )
    },
    canVirtualReserve(data, date) {
      return (
        data
          .filter(
            (d) => !d.buCode || d.buCode === this.shipment.headquarterCode
          )
          .filter(
            (d) =>
              !d.businessUnitId ||
              d.businessUnitId === this.shipment.primaryBusinessUnitId
          )
          .filter((d) => d.date === date)
          .filter((d) => d.upperLimit - d.used > 0).length > 0
      )
    },
    reserve(data, date) {
      var id = this.$route.query.id
      this.$http
        .get(
          `/warehouse-container-settings/check-if-long-distance-route/shipment/${id}/warehouse/${
            data[0].warehouseId
          }`
        )
        .then((lRes) => {
          if (lRes.data) {
            this.shipment.finallyWarehouseId = data[0].warehouseId
            this.shipment.forecastDeliveryDate = date
            this.$refs.longDistanceDialog.popup(
              this.shipment,
              this.today,
              '/B2300'
            )
          } else {
            this.$http
              .put(
                `/warehouse-container-settings/shipment/${
                  this.$route.query.id
                }/reserve`,
                {
                  reserveDate: date,
                  warehouseId: data[0].warehouseId,
                  buId: data[0].buId,
                  businessUnitId: data[0].businessUnitId,
                  vos: data,
                }
              )
              .then((res) => {
                if (res.data.success) {
                  this.send(id)
                } else {
                  this.$message('', res.data.localeMessage)
                }
              })
              .catch((err) => {
                this.$showError(err)
              })
          }
        })
    },
    getShipment() {
      var id = this.$route.query.id
      this.$http.get(`delivery-orders/do/${id}`).then((res) => {
        this.shipment = res.data
      })
    },
    filterData() {
      this.displayResults = this.results.filter(
        (d) =>
          (!this.query.warehouseId ||
            d[0].warehouseId === this.query.warehouseId) &&
          (d[0].companyCode === 'SJL' ||
            !this.query.buId ||
            d[0].buId === this.query.buId) &&
          (d[0].companyCode === 'SJL' ||
            !this.query.businessUnitId ||
            d[0].businessUnitId === this.query.businessUnitId)
      )
      this.virtualDisplayResults = this.virtualWarehouses.filter(
        (d) =>
          (!this.query.warehouseId ||
            d[0].warehouseId === this.query.warehouseId) &&
          (d[0].companyCode === 'SJL' ||
            !this.query.buId ||
            d[0].buId === this.query.buId) &&
          (d[0].companyCode === 'SJL' ||
            !this.query.businessUnitId ||
            d[0].businessUnitId === this.query.businessUnitId)
      )
    },
    send(id) {
      return this.$http
        .put(`/delivery-orders/${id}/send-email-date`)
        .then(() => {
          this.$message('', '納入指示済')
          this.$router.go(-1)
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    getVirtualWarehouses() {
      this.$http
        .get(`/warehouse-container-settings/virtual-warehouse-settings`)
        .then((res) => {
          res.data
            .map((r) => r.date)
            .forEach((d) => {
              if (this.virtualAvailDays.indexOf(d) === -1) {
                this.virtualAvailDays.push(d)
              }
            })

          this.virtualAvailDays = this.virtualAvailDays.sort((a, b) =>
            a.localeCompare(b)
          )

          this.virtualAvailDays.forEach((day) => {
            this.virtualHeaders.push({
              text: day,
              sortable: false,
            })
          })
          res.data.forEach((r) => {
            r.availableDays = this.virtualAvailDays
          })

          this.virtualWarehouses = this.initData(res.data)

          this.virtualWarehouses = this.virtualWarehouses.sort((a, b) => {
            return this.$sortByProps(a[0], b[0], {
              warehouseCode: 'desc',
              buId: 'desc',
            })
          })
          this.virtualWarehouses.forEach((r) => {
            r = r.sort((a, b) => {
              return this.$sortByProps(a, b, {
                productGroupName: 'desc',
              })
            })
          })
          this.virtualWarehouses = this.virtualWarehouses.sort((a, b) => {
            return this.$sortByProps(a[0], b[0], {
              seq: 'ascending',
            })
          })

          this.virtualDisplayResults = this.virtualWarehouses
          console.log(res.data)
        })
    },
  },
  watch: {
    'query.warehouseId'() {
      this.filterData()
    },
    'query.buId'() {
      this.filterData()
    },
    'query.businessUnitId'() {
      this.filterData()
    },
  },
  computed: {
    isMe() {
      return (
        this.shipment.headquarterId === '47ceb6d6-520a-40b7-9a94-f9de756eb70b'
      )
    },
    today() {
      return DateFormat(new Date(), 'yyyy-mm-dd')
    },
  },
  mounted() {
    this.initDate()
    this.getShipment()
    this.getVirtualWarehouses()
  },
}
</script>

<style scoped>
.qtyLeft {
  display: flex;
}

.qtyLeft > div {
  flex: 1;
  text-align: left;
  align-self: center;
}

.reserveBtn {
  flex: 1;
}

.row-1 td {
  padding: 5px;
  border-bottom: 1px solid #f0f0f0;
}

.info-1 {
  display: flex;
  column-gap: 15px;
}

.row-0 {
  display: flex;
}

.col-0,
.col-1 {
  width: 50%;
}

.col-1 {
  border-left: 1px solid #f0f0f0;
  padding: 15px;
}
</style>
